import React, { useEffect, useState } from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { SafeAreaView, ScrollView } from 'react-native'
import { ATLNavigationButton } from '@appsimples/atlantica-react-native'
import { ItemContainer } from './Components'
import { CustomHeader } from '../../components/CustomHeader'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { atlTheme } from '../../atlTheme'
import { useGlobal } from '../../global/useGlobal'
import { getQuestionsAndAnswers } from './faqFormatters'
import { getFaqs_listFaqCategories_questions } from '../../services/types/getFaqs'

export const QuestionScreen: NavigationStackScreenComponent = navigation => {
  const category = navigation?.route?.params?.category

  const [faqs] = useGlobal('faqs')
  const [questions, setQuestions] = useState<getFaqs_listFaqCategories_questions[]>()

  useEffect(() => {
    const questionsObjects = getQuestionsAndAnswers(faqs, category)
    setQuestions(questionsObjects)
  }, [])

  return (
    <SafeAreaView>
      <ScrollView>
        {questions?.map(question => {
          return (
            <ItemContainer>
              <ATLNavigationButton
                text={question.question}
                onPressCell={() => Coordinator.goToAnswers(category, question.question, question.answer)}
                rightIconBaseProps={{
                  tintColor: atlTheme.ColorBrand1Default,
                }}
                labelBaseProps={{
                  textColor: atlTheme.ColorHighContrast,
                  fontWeight: atlTheme.FontWeight500,
                }}
              />
            </ItemContainer>
          )
        })}
      </ScrollView>
    </SafeAreaView>
  )
}

QuestionScreen.navigationOptions = CustomHeader('', true, () => Coordinator.goBack())
